import type { CSSProperties } from "react";
import { PEWTER_OUTLINE } from "./pewter-edge";
import { panelStyle } from "./card-frame";

/**
 * The life of a floating panel — moved to `@majourneys/ui`.
 *
 * It had to move: two of the site's four hand-written dropdowns live in
 * `@majourneys/discover`, which cannot import from this app, so the one home
 * for open / outside-press / Escape / focus-return had to be a package. This
 * file re-exports it so the header's five menus, the search suggestions and the
 * design labs keep importing from where they always have.
 *
 * The frame helpers stay here, because they are built on the card frame and a
 * card is an app concept. `@majourneys/ui` builds the same frame for its menus
 * straight from `@majourneys/shared/ui`.
 */
export {
  POP_MS,
  popOrigin,
  useMenu,
  useMenuGroup,
  usePresence,
  type MenuGroup,
} from "@majourneys/ui";

const FLOAT_SHADOW = "0 18px 44px -18px rgba(17,14,57,0.45)";

/** The frame's own white outline stays under the float. */
export const FLOAT_FRAME_SHADOW = `0 0 0 1px ${PEWTER_OUTLINE}, ${FLOAT_SHADOW}`;

/**
 * The house frame on a panel that hangs over the page — a menu, the phone's
 * bottom bar — with the float shadow in place of the quiet panel one.
 */
export function floatPanelStyle(radius: number): CSSProperties {
  return {
    ...panelStyle(radius),
    boxShadow: `${FLOAT_FRAME_SHADOW}, inset 0 0 0 1px rgba(17,14,57,0.13)`,
  };
}
